// Brand Lift Survey — client-side mirror of the server validation (server stays the authority).
export const BLS_IDS = ["bls-vast", "bls-web"];
export const isBls = (tid) => BLS_IDS.includes(tid);

export const titleCase = (s) => String(s == null ? "" : s).replace(/(^|\s)(\S)/g, (m, a, b) => a + b.toUpperCase());

export function mintStudyId() {
  const a = new Uint8Array(3);
  (window.crypto || window.msCrypto).getRandomValues(a);
  return "bls_" + Array.from(a).map((x) => x.toString(16).padStart(2, "0")).join("");
}

export function validateBls(cfg) {
  const e = {};
  if (!String(cfg.question || "").trim()) e.question = "Required.";
  else if (cfg.question.length > 120) e.question = "Max 120 characters.";
  const answers = cfg.answers || [];
  if (answers.length < 2 || answers.length > 6) e.answers = "Between 2 and 6 answers are required.";
  else if (answers.some((a) => !String(a.label || "").trim() || a.label.length > 40)) e.answers = "Every answer needs a label of at most 40 characters.";
  else if (!answers.some((a) => a.positive)) e.answers = "Mark at least one answer as positive (counts toward lift).";
  const tu = String(cfg.termsUrl || "").trim();
  if (!tu) e.termsUrl = "Terms & Conditions URL is required.";
  else if (!/^https:\/\/[^\s/]+/i.test(tu)) e.termsUrl = "Must be an absolute https:// URL.";
  const tr = cfg.trackingUrls || {};
  const missing = ["bls_view", "bls_answer_select", "bls_submit", "bls_skip", "bls_terms_open"].filter((k) => !/^(https?:\/\/|\{STUDIO_T\})/.test(String(tr[k] || "").trim()));
  if (missing.length) e.trackingUrls = `A pixel URL (http/https) is required for every event — missing ${missing.join(", ")}.`;
  if (!(cfg.macros || []).some((m) => String(m.key || "").trim() === "arm")) e.macros = "The 'arm' macro is required (exposed | control).";
  return e;
}

// Server error body → { message, errors }
export function serverErrors(err) {
  const d = err && err.response && err.response.data && err.response.data.detail;
  if (d && typeof d === "object" && d.errors) return { message: d.message || "Validation failed", errors: d.errors };
  return { message: typeof d === "string" ? d : "Save failed", errors: {} };
}
